module.exports = __webpack_public_path__ + "img/my_audits.199cebd4.svg";